import React, { useEffect, useState } from "react"
import { InputNumber, message } from "antd"

interface ICampaignTargetAcosCell {
  override?: number
  inherited: number
  onSave: (targetAcos: number) => Promise<void>
}

const INHERIT = 0

const toOverride = (value?: number | null): number | null => (value && value > 0 ? value : null)

const CampaignTargetAcosCell: React.FC<ICampaignTargetAcosCell> = ({
  override,
  inherited,
  onSave,
}) => {
  const [draft, setDraft] = useState<number | null>(toOverride(override))
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    setDraft(toOverride(override))
  }, [override])

  async function commit() {
    const next = draft ?? INHERIT
    if (next === (override ?? INHERIT)) {
      return
    }
    setSaving(true)
    try {
      await onSave(next)
    } catch {
      message.error("Failed to save Target ACoS")
      setDraft(toOverride(override))
    } finally {
      setSaving(false)
    }
  }

  return (
    <InputNumber
      size="small"
      min={0}
      max={100}
      value={draft}
      placeholder={String(inherited)}
      disabled={saving}
      onChange={(value) => setDraft(toOverride(value))}
      onBlur={commit}
      onPressEnter={commit}
      onClick={(event) => event.stopPropagation()}
      style={{ width: 70 }}
    />
  )
}

export default CampaignTargetAcosCell
